import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import Link from './Link';
import Image from './Image';

const propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.object,
    picture: PropTypes.object,
};

const defaultProps = {
    title: 'Title',
    quote: null,
    description: 'Lorem ipsum.....',
    link: null,
    picture: null,
};

class Feature extends Component {
    render() {
        const {
            title,
            description,
            picture,
            link,
        } = this.props;

        if (isEmpty(picture) && isEmpty(title) && isEmpty(description)) {
            return null;
        }

        const content = (
            <span className="feature-content">
                { picture !== null ? (
                    <Image media={picture} />
                ) : null}
                <span className="align-bottom">
                    { title !== null ? (
                        <strong className="title">{title}</strong>
                    ) : null}
                    { description !== null ? (
                        <span className="description">{description}</span>
                    ) : null}
                </span>
            </span>
        );

        return (
            <div className="container feature-container">
                { link !== null ? (
                    <Link to={link.pathname}>
                        { content }
                    </Link>
                ) : content }
            </div>
        );
    }
}

Feature.propTypes = propTypes;
Feature.defaultProps = defaultProps;

export default Feature;



// WEBPACK FOOTER //
// ./components/partials/Feature.jsx